import {Mapper} from '@s-ui/domain'

export default class HTTPUserTakeOutListToUserTakeOutListValueObjectMapper extends Mapper {
  constructor({userTakeoutListValueObjectFactory, config}) {
    super()
    this._userTakeoutListValueObjectFactory = userTakeoutListValueObjectFactory
    this._config = config
  }

  map = httpUserTakeOutListResponse => {
    const STATUS_UNAVAILABLE = 'unavailable'

    if (!httpUserTakeOutListResponse.status) {
      return this._userTakeoutListValueObjectFactory({
        status: STATUS_UNAVAILABLE,
        filenames: [],
        requestId: null,
        messages: this._config.get('USER_TAKEOUT_RESPONSES')[STATUS_UNAVAILABLE]
      })
    }

    return this._userTakeoutListValueObjectFactory({
      ...httpUserTakeOutListResponse,
      messages: this._config.get('USER_TAKEOUT_RESPONSES')[httpUserTakeOutListResponse.status]
    })
  }
}
